export default {
      id: "consultations-usage",
      viewBox: "0 0 64 55",
      url: "../dist/images/" + "sprite.svg#consultations-usage",
      toString: function () {
        return this.url;
      }
    }